import { PercentCircleOutlineIcon } from './PercentCircleOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 30332F97-18B5-4866-A31F-912C262ACDBE
 * name percent-circle-outline
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/percent-circle-outline.svg
 * tags
 * - Math 
 * - Shopping 
 */
export const SaleCircleOutlineIcon = PercentCircleOutlineIcon;
export default SaleCircleOutlineIcon